__turbopack_context__.v({
  "body_rich_text": "Brands-module-scss-module__cyod3W__body_rich_text",
  "direction__column": "Brands-module-scss-module__cyod3W__direction__column",
  "direction__row": "Brands-module-scss-module__cyod3W__direction__row",
  "gradient-glow-blue": "Brands-module-scss-module__cyod3W__gradient-glow-blue",
  "gradient-glow-neon": "Brands-module-scss-module__cyod3W__gradient-glow-neon",
  "gradient-glow-orange": "Brands-module-scss-module__cyod3W__gradient-glow-orange",
  "gradient-glow-pink": "Brands-module-scss-module__cyod3W__gradient-glow-pink",
  "gradient-glow-snap-pea": "Brands-module-scss-module__cyod3W__gradient-glow-snap-pea",
  "gradient-neon-pink": "Brands-module-scss-module__cyod3W__gradient-neon-pink",
  "gradient-pink-blue": "Brands-module-scss-module__cyod3W__gradient-pink-blue",
  "gradient-pink-orange": "Brands-module-scss-module__cyod3W__gradient-pink-orange",
  "layout__content-leading": "Brands-module-scss-module__cyod3W__layout__content-leading",
  "layout__content-trailing": "Brands-module-scss-module__cyod3W__layout__content-trailing",
  "module-base": "Brands-module-scss-module__cyod3W__module-base",
  "module-content-swap": "Brands-module-scss-module__cyod3W__module-content-swap",
  "module_block__contained": "Brands-module-scss-module__cyod3W__module_block__contained",
  "module_block__uncontained": "Brands-module-scss-module__cyod3W__module_block__uncontained",
  "module_breadcrumbs": "Brands-module-scss-module__cyod3W__module_breadcrumbs",
  "section_bg_fill__base": "Brands-module-scss-module__cyod3W__section_bg_fill__base",
  "section_bg_fill__gradient": "Brands-module-scss-module__cyod3W__section_bg_fill__gradient",
  "section_bg_fill__no-fill": "Brands-module-scss-module__cyod3W__section_bg_fill__no-fill",
  "section_bg_fill__raised": "Brands-module-scss-module__cyod3W__section_bg_fill__raised",
  "section_container": "Brands-module-scss-module__cyod3W__section_container",
  "with_breadcrumb": "Brands-module-scss-module__cyod3W__with_breadcrumb",
  "with_navbar": "Brands-module-scss-module__cyod3W__with_navbar",
});
